import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import dispatchMiddleware from "./middleware/auth/dispatchValidRoute";

// ✅ Lazy imports
const ReadyForDispatchList = lazy(() => import("app/pages/Inventory/ReadyForDispatch/List"));
const ListDispatch = lazy(() => import("app/pages/VeneerOrder/Dispatch/List"));
const CreateGroupDispatch = lazy(() => import("app/pages/VeneerOrder/Dispatch/Create/createGroupDispatch"));
const CreateRawDispatch = lazy(() => import("app/pages/VeneerOrder/Dispatch/Create/createRawDispatch"));

export const dispatchRoutes = [
  {
    middleware: [
      {
        element: dispatchMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/readyForDispatch",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ReadyForDispatchList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/dispatch",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListDispatch} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/dispatch/create-group-dispatch",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateGroupDispatch} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/dispatch/create-raw-dispatch",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateRawDispatch} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
